import { LinkItem } from '@occc-app/design-system';
import { Cpg, ScanDataSftpCredentialStatus } from '@occc/graphql';

import { ScanDataSubmissionGroupsCreateFormValues } from './scan-data-submission-groups-create.types';

import { routeCreator } from '../../scan-data.router';

export const breadcrumbLinks: LinkItem[] = [
  { to: routeCreator.base(), label: 'Scan Data' },
  { key: 'Create Submission Group', label: 'Create Submission Group' },
];

export const tobaccoCompanyOptions: { label: string; value: Cpg }[] = [
  { label: 'Altria', value: Cpg.Altria },
  { label: 'RJR', value: Cpg.Circana },
  { label: 'MSA', value: Cpg.Msa },
];

export const submissionTypeOptions: { label: string; value: ScanDataSftpCredentialStatus }[] = [
  { label: 'Production Submission', value: ScanDataSftpCredentialStatus.ProductionSubmission },
  { label: 'QA Submission', value: ScanDataSftpCredentialStatus.QaSubmission },
];

export const initialValues: Partial<ScanDataSubmissionGroupsCreateFormValues> = {
  name: '',
  tobaccoCompany: Cpg.Altria,
  submissionType: ScanDataSftpCredentialStatus.ProductionSubmission,
  sftpDetails: {
    username: '',
    password: '',
    portNumber: '',
    submissionURL: '',
    submitterID: '',
  },
};
